import { render, staticRenderFns } from "./UserMyPurchasesTabs.vue?vue&type=template&id=0fedb7c1&"
import script from "./UserMyPurchasesTabs.vue?vue&type=script&lang=js&"
export * from "./UserMyPurchasesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports